import { z } from "zod";
export var UserRole;
(function (UserRole) {
    UserRole["DISPATCHER"] = "DISPATCHER";
    UserRole["ADMINISTRATOR"] = "ADMINISTRATOR";
    UserRole["TECHNICIAN"] = "TECHNICIAN";
    UserRole["MANAGER"] = "MANAGER";
})(UserRole || (UserRole = {}));
export const zUserRoleSchema = z.enum([
    UserRole.DISPATCHER,
    UserRole.ADMINISTRATOR,
    UserRole.TECHNICIAN,
    UserRole.MANAGER,
]);
export const zEmployeeCommonSchema = z.object({
    id: z.string(),
    email: z.string().nullish(),
    firstName: z.string(),
    lastName: z.string(),
    middleName: z.string().nullish(),
    phone: z.string().nullish(),
    role: zUserRoleSchema,
    isActive: z.boolean().nullish(),
    idCreatedBy: z.string().nullish(),
    idUpdatedBy: z.string().nullish(),
    isDeleted: z.boolean().nullish(),
    authUUID: z.string().nullish(),
    imgURL: z.string().nullish(),
});
// Права доступа для ролей
export var Permission;
(function (Permission) {
    // Права на справочники
    Permission["DICTIONARIES_READ"] = "DICTIONARIES_READ";
    Permission["DICTIONARIES_WRITE"] = "DICTIONARIES_WRITE";
    Permission["DICTIONARIES_DELETE"] = "DICTIONARIES_DELETE";
    // Права на заказы
    Permission["ORDERS_READ"] = "ORDERS_READ";
    Permission["ORDERS_WRITE"] = "ORDERS_WRITE";
    Permission["ORDERS_DELETE"] = "ORDERS_DELETE";
    // Права на отчеты
    Permission["REPORTS_READ"] = "REPORTS_READ";
    Permission["REPORTS_EXPORT"] = "REPORTS_EXPORT";
    // Административные права
    Permission["USERS_MANAGE"] = "USERS_MANAGE";
    Permission["SYSTEM_SETTINGS"] = "SYSTEM_SETTINGS";
    // Права на чат
    Permission["CHAT_READ"] = "CHAT_READ";
    Permission["CHAT_WRITE"] = "CHAT_WRITE";
    // Корпоративные клиенты
    Permission["COMPANIES_READ"] = "COMPANIES_READ";
    Permission["COMPANIES_WRITE"] = "COMPANIES_WRITE";
    Permission["SETTLEMENTS_READ"] = "SETTLEMENTS_READ";
    Permission["SETTLEMENTS_WRITE"] = "SETTLEMENTS_WRITE";
})(Permission || (Permission = {}));
export const zUserWithEmployeeSchema = z.object({
    id: z.string(),
    email: z.string().nullish(),
    employee: zEmployeeCommonSchema,
});
// Карта ролей и их разрешений
export const ROLE_PERMISSIONS = {
    [UserRole.DISPATCHER]: [
        Permission.DICTIONARIES_READ,
        Permission.DICTIONARIES_WRITE,
        Permission.ORDERS_READ,
        Permission.ORDERS_WRITE,
        Permission.REPORTS_READ,
        Permission.CHAT_READ,
        Permission.CHAT_WRITE,
        Permission.COMPANIES_READ,
        Permission.COMPANIES_WRITE,
    ],
    [UserRole.ADMINISTRATOR]: [
        Permission.DICTIONARIES_READ,
        Permission.DICTIONARIES_WRITE,
        Permission.DICTIONARIES_DELETE,
        Permission.ORDERS_READ,
        Permission.ORDERS_WRITE,
        Permission.ORDERS_DELETE,
        Permission.REPORTS_READ,
        Permission.REPORTS_EXPORT,
        Permission.USERS_MANAGE,
        Permission.SYSTEM_SETTINGS,
        Permission.CHAT_READ,
        Permission.CHAT_WRITE,
        Permission.COMPANIES_READ,
        Permission.COMPANIES_WRITE,
        Permission.SETTLEMENTS_READ,
        Permission.SETTLEMENTS_WRITE,
    ],
    [UserRole.TECHNICIAN]: [Permission.ORDERS_READ, Permission.ORDERS_WRITE],
    [UserRole.MANAGER]: [
        Permission.DICTIONARIES_READ,
        Permission.ORDERS_READ,
        Permission.REPORTS_READ,
        Permission.REPORTS_EXPORT,
    ],
};
export const zEmployeeFiltersSchema = z.object({
    search: z.string().optional(),
});
